<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="策略名称" name="name"></c-form-item>
					<c-form-item type="select" label="应用场景" name="apply_type" :options="applyType"></c-form-item>
					<c-form-item type="datetime" label="生效时间" start-name="start_start_date" end-name="end_start_date"></c-form-item>
				</c-form>
			</m-search>

<!--
			<m-operate>
				<c-button power="b_recommended_add" color="sys" @click="add()">新增</c-button>
			</m-operate>
-->

			<c-table ref="table" code="recommended_list">

        <c-table-column
            label="状态"
            name="state"
            width="60"
        >
          <template v-slot="{data}">
            <span style="color:darkgreen" v-if="data.state==2">启用</span>
            <span style="color:red" v-if="data.state==1">禁用</span>
          </template>
        </c-table-column>

				<c-table-column
					label="策略名称"
					name="name"
          width="150"
        >
				</c-table-column>

				<c-table-column
						label="应用场景"
						name="apply_type"
            width="150"
        >
					<template v-slot="{data}">{{applyTypeName[data.apply_type]}}</template>
				</c-table-column>

				<c-table-column
					label="展示方式"
					name="type"
          width="80"
        >
          <template v-slot="{data}">
            <span style="color:blue" v-if="data.type=='随机展示'">随机展示</span>
            <span style="color:brown" v-if="data.type=='顺序展示'">顺序展示</span>
          </template>
				</c-table-column>

				<c-table-column
					label="生效日期"
					name="start_date"
          width="150"
        >
				</c-table-column>

				<c-table-column
					label="商品数量"
					name="product_amount"
          width="80"
        >
				</c-table-column>

        <c-table-column
            label="备注"
            name="remark"
            width="200"
        >
        </c-table-column>

				<c-table-column
					label="创建日期"
					name="create_date"
          width="150"
        >
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
							<c-table-button power="b_recommended_edit" @click="edit(data)">编辑</c-table-button>
							<c-table-button power="b_recommended_state" v-if="data.state == 1"  @click="updateState(2,data)">启用</c-table-button>
							<c-table-button power="b_recommended_state" v-if="data.state == 2"  @click="updateState(1,data)">禁用</c-table-button>
<!--							<c-table-button power="b_recommended_del" @click="del(data)">删除</c-table-button>-->
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_recommended',

		data() {
			return {
				applyType:[
            {name:'商品详情推荐',value:1},
            {name:'购物车推荐',value:2},
            {name:'支付成功页推荐',value:3},
            {name:'个人中心页推荐',value:4}
				],
				applyTypeName: {
            1: '商品详情推荐',
            2: '购物车推荐',
            3: '支付成功页推荐',
            4: '个人中心页推荐'
        }
			}
		},

		mounted() {
			this.$refs.search.search();

			this.$bus.$on('recommendedList.update', page => {
				this.$refs.table.update(page);
			});
		},

		methods: {

			searchHandle(data) {
				this.$refs.table.load({
					url: '/recommended/list',
					data
				});
			},

			add() {
				this.navigateTo('/recommended_add');
			},

			edit(val) {
				this.navigateTo('/recommended_edit/' + val.id);
			},

			del(val) {
				this.$confirm({
					text: '确定要删除【'+val.name+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/recommended/remove',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			updateState(type,val) {
				this.$confirm({
					text: '确定要'+(type==1?'启用':'禁用')+'【'+val.name+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/recommended/update_state',
							data: {id:val.id,state:type},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
		}
	}
</script>